module.exports = "/packs/thumbnail_mokumoku-5788a7575ba79de5252ecf280ea52297.png";